import { PageEnum } from '@/enums/pageEnum';
import { LAYOUT } from '@/router/constant';
import { AppRouteModule } from '@/router/types';
import { t } from '@/hooks/web/useI18n';

const userInfo: AppRouteModule = {
    path: '/user-info',
    name: 'UserInfo',
    component: LAYOUT,
    redirect: '/user-info/index',
    meta: {
        title: t('routes.index.userInfo.userInfo'),
    },
    children: [
        {
            path: 'index',
            name: PageEnum.USERINFO,
            component: () => import('@/views/main/user-info/user-info.vue'),
            meta: {
                title: t('routes.index.userInfo.index'),
            },
        },
        {
            path: 'medal',
            name: PageEnum.MEDAL,
            component: () => import('@/views/main/medal/medal.vue'),
            meta: {
                title: t('routes.index.userInfo.medal'),
            },
        },
        {
            path: 'collection',
            name: PageEnum.COLLECTION,
            component: () => import('@/views/main/collection/collection.vue'),
            meta: {
                title: t('routes.index.userInfo.collection'),
            },
        },
    ],
};

export default userInfo;
